import contact from './contact.reducer'
import player from './player.reducer'

const reducers = {
  contact,
  player
}

export default reducers